export default __webpack_public_path__ + "static/media/dadu.8307d294.svg";